<template>
  <footer
    class="justopp-footer bg-lead c-text z-effect-2 padding-xl-vertical relative z-level-2">
    <div class="container container-l">
      <div
        class="sections flex flex-column-reverse l:flex-row flex-center flex-top flex-wrap gap-l width-expand l:flex-between l:flex-stretch">
        <div class="logo footer-item flex-middle flex-center" style="align-self: stretch">
          <img
            class="margin-m-bottom"
            style="width: 180px; flex: 0 0 180px; height: auto"
            :src="getDynamicAssetUrl('images/logos/logob.svg')"
            alt="logo" />
        </div>
        <div
          class="footer-item links flex-top flex-start l:flex-center flex-wrap gap-max">
          <div class="footer-nav">
            <h4 class="margin-remove">
              <saffron-link
                class="plain-link"
                :to="{ name: 'content-styled-article-alias', params: { alias: 'about-us' } }">
                {{ translateTitleCase("justopp.footer.about") }}
              </saffron-link>
            </h4>
            <ul class="margin-bottom-remove">
              <li>
                <saffron-link
                  class="c-text"
                  :to="{
                    name: 'content-styled-article-alias',
                    params: { alias: 'about-us' },
                    hash: '#article-section-0',
                  }">
                  {{ translateUcFirst("justopp.footer.howItWorks") }}
                </saffron-link>
              </li>

              <li>
                <saffron-link
                  :to="{
                    name: 'content-styled-article-alias',
                    params: { alias: 'about-us' },
                    hash: '#article-section-1',
                  }">
                  {{ translateUcFirst("justopp.footer.ourVision") }}
                </saffron-link>
              </li>
              <li>
                <saffron-link
                  :to="{
                    name: 'content-styled-article-alias',
                    params: { alias: 'about-us' },
                    hash: '#article-section-2',
                  }">
                  {{ translateUcFirst("justopp.footer.benefits") }}
                </saffron-link>
              </li>
              <li>
                <saffron-link :to="{ name: 'store-deals' }">
                  {{ translateUcFirst("justopp.footer.offers") }}
                </saffron-link>
              </li>
              <li>
                <saffron-link
                  :to="{
                    name: 'content-styled-article-alias',
                    params: { alias: 'privacy-policy' },
                  }">
                  {{ translateUcFirst("justopp.footer.privacyPolicy") }}
                </saffron-link>
              </li>
              <li>
                <saffron-link
                  :to="{
                    name: 'content-styled-article-alias',
                    params: { alias: 'terms-of-service' },
                  }">
                  {{ translateUcFirst("justopp.footer.termsOfService") }}
                </saffron-link>
              </li>
            </ul>
          </div>

          <div class="footer-nav">
            <h4 class="margin-remove">
              <saffron-link
                class="plain-link"
                :to="{ name: 'content-styled-article-alias', params: { alias: 'about-us' } }">
                {{ translateTitleCase("justopp.footer.solutions.title") }}
              </saffron-link>
            </h4>
            <ul>
              <li>
                <saffron-link
                  class="c-text"
                  :to="
                    userVendor
                      ? {
                          name: 'company-vendorId-dashboard',
                          params: { vendorId: userVendor.id },
                        }
                      : { name: 'vendor-register' }
                  ">
                  {{ translateUcFirst("justopp.footer.solutions.seller") }}
                </saffron-link>
              </li>
              <li>
                <saffron-link
                  class="c-text"
                  :to="{ name: isLoggedIn ? 'user-dashboard' : 'user-register' }">
                  {{ translateUcFirst("justopp.footer.solutions.buyer") }}
                </saffron-link>
              </li>
            </ul>
          </div>
          <div class="footer-nav">
            <h4 class="margin-remove">
              <saffron-link
                :to="{ name: 'content-styled-article-alias', params: { alias: 'services' } }">
                {{ translateTitleCase("justopp.footer.services") }}
              </saffron-link>
            </h4>
            <ul>
              <li>
                <saffron-link
                  :to="{
                    name: 'content-styled-article-alias',
                    params: { alias: 'services' },
                    hash: '#article-section-1',
                  }">
                  {{ translateUcFirst("justopp.footer.logistics") }}
                </saffron-link>
              </li>
              <li>
                <span class="cursor-pointer" @click="isShowingRequestProductForm = true">{{ translateUcFirst("justopp.footer.requestProduct") }}</span>
                <!-- <saffron-link
                  :to="{
                    name: 'content-styled-article-alias',
                    params: { alias: 'services' },
                    hash: '#article-section-2',
                  }">
                  <span>{{ translateUcFirst("justopp.footer.requestProduct") }}</span>
                </saffron-link> -->
              </li>
              <li>
                <saffron-link
                  v-if="isLoggedIn && userVendor"
                  class="plain-link"
                  :to="{
                    name: 'company-vendorId-dashboard',
                    params: { vendorId: userVendor.id },
                  }">
                  {{ translateUcFirst("justopp.footer.dashboard") }}
                </saffron-link>
              </li>
            </ul>
          </div>
        </div>

        <div class="spacer width-100"></div>

        <div
          class="follow footer-item padding-l-bottom width-expand flex-middle flex-center flex-column gap-m flex-start flex-top mobile-seperator">
          <h4 class="margin-xs-bottom">
            {{ translateTitleCase("justopp.footer.follow.title") }}
          </h4>
          <div  v-if="!isRegisteredToNewsletter">
            <p class="margin-l-bottom">{{ t("justopp.footer.follow.text") }}</p>

            <div class="email-form flex-middle flex-bottom padding-l-bottom ">
              <base-form ref="newsletterForm"
                         method="post"
                         @form:submit-success="handleSuccessfulNewsletterRegistration"
                         action="justopp/lead/newsletter"
                         :field-wrapper-margin="false"
                         :error-display-position="'absolute'"
                         :config="newsletterFormConfig" v-model="newsletterRegistrationData"></base-form>
              <form-button theme="inverse-lead"
                           @click="$refs.newsletterForm.submit()">{{
                  t("justopp.footer.follow.submit")
                }}</form-button>
            </div>
          </div>

          <div class="email-form flex-middle flex-bottom padding-l-bottom "  v-if="isRegisteredToNewsletter">
            <h4 class="margin-remove">
              {{tu('justopp.newsletterLead.alreadyRegisteredText')}}
            </h4>
          </div>
        </div>

        <div
          class="contact footer-item width-expand flex-middle flex-center flex-column gap-m flex-start flex-top mobile-seperator">
          <h4 class="margin-xs-bottom">
            {{ translateTitleCase("justopp.footer.contact") }}
          </h4>

          <div class="contact-items flex-between flex-middle width-expand">
            <div class="footer-contact-item flex-middle gap-s">
              <a class="underline" href="mailto:info@JustOpp.com" target="_blank"
                >info@JustOpp.com</a
              >
            </div>
            <div class="footer-contact-item footer-contact-item--social flex gap-m">
              <a href="https://www.linkedin.com/company/justopp/" target="_blank">
                <icon-halo
                  halo-theme="lead"
                  theme="text"
                  :size="1.5"
                  icon="linkedin"
                  class="cursor-pointer"></icon-halo>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="flex flex-middle flex-center width-expand text-center margin-2xl-top">
        <span href="#">{{ translateUcFirst("justopp.footer.allRightsReserved") }}</span>
      </div>
    </div>
    <modal
      :show="isShowingRequestProductForm"
      @modal:closed="isShowingRequestProductForm = false"
      title="justopp.productRequest.modalTitle"
      :show-footer="false">
      <div class="product-request-wrap">
        <p class="margin-l-bottom">
          {{tu('justopp.productRequest.modalExplain')}}
        </p>
        <product-requester  @product-requester:success="isShowingRequestProductForm = false">

        </product-requester>
      </div>
    </modal>
  </footer>
</template>

<script>
import ProductRequester from "@/client/applications/justopp/components/widgets/ProductRequester.vue"

export default {
  components: {
    ProductRequester
  },
  data: function () {
    return {
      isRegisteredToNewsletter : false,
      newsletterFormConfig: {
        fields: {
          email: {
            name: "email",
            type: "email",
            label: "justopp.footer.follow.inputLabel",
            placeholder: false,
            validation: {
              required: {},
              email: {},
            }
          },
        },
        buttons: {},
      },
      newsletterRegistrationData: {},
      userEmail: "",
      isShowingRequestProductForm : false,
    };
  },
  computed: {
    isLoggedIn() {
      return this.$store.getters["user/isLoggedIn"];
    },
    userProfile() {
      return this.$store.getters["user/profile"];
    },
    userVendor() {
      if (!this.userProfile) {
        return false;
      }

      if (!this.userProfile.Vendor) {
        return false;
      }

      return this.userProfile.Vendor;
    },
  },
  methods: {
    subscribeEmail() {
      if (this.email != "") {
        // subscribe to newsletter
        this.email = "";
      }
    },
    handleSuccessfulNewsletterRegistration() {
      this.isRegisteredToNewsletter = true;
      this.newsletterRegistrationData = {};
      this.$s.ui.notification('justopp.newsletterLead.successNotification','success');
    }
  },
};
</script>

<style scoped lang="scss">
.justopp-footer {
  min-height: 200px;
  border-top: 5px solid var(--c-lead);
}

.footer-nav {
  ul {
    padding-inline-start: 0;
    list-style: none;

    li {
      margin-bottom: var(--margin-s);
    }
  }
}

.mobile-seperator {
  @media (max-width: 1024px) {
    border: 0 solid var(--c-text);
    border-bottom-width: 1px;
    padding-bottom: var(--margin-l);
  }
}

:deep(a:not(button, .button)) {
  color: var(--c-text);
}

@media (min-width: 1024px) {
  .logo {
    justify-content: flex-start;

    flex: 0 1 100%;
  }
  .follow {
    max-width: 340px;
    flex: auto;
    padding-bottom: 0 !important;
    justify-content: space-between !important;
  }

  .contact {
    flex-direction: column;
    width: auto;
    flex: auto;

    .contact-items {
      flex-direction: column;
      width: auto;
      align-items: flex-start;
    }
  }

  .email-form {
    padding-bottom: 0 !important;
    column-gap: var(--margin-m);

    :deep(.field__controls) {
      border-color: var(--c-text);
    }
    :deep(input) {
      background-color: var(--c-lead);
    }
  }

  .sections {
    column-gap: var(--margin-max) !important;
    padding-bottom: var(--margin-max);
  }

  .links {
    gap: var(--margin-2xl) !important;

    :nth-child(2) {
      order: 1;
    }
  }
}

.margin-bottom-remove {
  margin-bottom: 0;
}
</style>
